<template>
  <div class="tooglebox-wrap" @click="onClickToogle">
    <input
      type="checkbox"
      :class="tooglevalue ? 'on' : 'off'"
      :value="tooglevalue"
      :checked="tooglevalue"
      ref="indicator"
    />
    <label class="toogle-label" :class="tooglevalue ? 'on' : 'off'" for="checkbox">
      {{ tooglevalue ? ontext : offtext }}
    </label>
  </div>
</template>
<script>
export default {
  props: {
    tooglevalue: {
      type: Boolean,
      default: false,
      required: false
    },
    ontext: {
      type: String,
      default: '',
      required: false
    },
    offtext: {
      type: String,
      default: '',
      required: false
    }
  },
  emits: ['click-toogle', 'transition-end'],
  mounted() {
    const el = this.$refs.indicator;
    el.addEventListener('transitionend', this.onTransitionEnd);
  },
  beforeDestroy() {
    const el = this.$refs.indicator;
    el.removeEventListener('transitionend', this.onTransitionEnd);
  },
  methods: {
    onTransitionEnd() {
      this.$emit('transition-end');
    },
    onClickToogle(e) {
      e.preventDefault();
      this.$emit('click-toogle');
    }
  }
};
</script>
<style scoped src="@/assets/css/togglebox/togglebox.css"></style>
